import React, { useCallback, useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
type ModalType = 'privacy' | 'terms' | null;
const privacyContent = {
  title: 'Política de Privacidad',
  sections: [{
    heading: '1. Información que Recopilamos',
    text: 'Recopilamos información personal que nos proporcionas directamente al realizar una compra, como tu nombre, dirección de correo electrónico y datos de pago. También podemos recopilar información de uso de forma automática cuando navegas por nuestro sitio web, incluyendo tu dirección IP, tipo de navegador y páginas visitadas.'
  }, {
    heading: '2. Uso de la Información',
    text: 'Utilizamos tu información personal para procesar tus pedidos, enviarte el contenido digital adquirido, comunicarnos contigo sobre tu compra y mejorar nuestros productos y servicios. No compartimos tu información personal con terceros con fines de marketing sin tu consentimiento explícito.'
  }, {
    heading: '3. Protección de Datos',
    text: 'Implementamos medidas de seguridad técnicas y organizativas apropiadas para proteger tu información personal contra el acceso no autorizado, la alteración, la divulgación o la destrucción. Todos los pagos se procesan a través de plataformas seguras con encriptación SSL.'
  }, {
    heading: '4. Cookies',
    text: 'Nuestro sitio web utiliza cookies para mejorar tu experiencia de navegación, analizar el tráfico del sitio y personalizar el contenido. Puedes configurar tu navegador para rechazar cookies, aunque esto puede afectar la funcionalidad del sitio.'
  }, {
    heading: '5. Tus Derechos',
    text: 'Tienes derecho a acceder, rectificar, eliminar o limitar el procesamiento de tus datos personales. Para ejercer estos derechos, puedes contactarnos a través de los canales indicados en nuestro sitio web. Responderemos a tu solicitud en un plazo máximo de 30 días.'
  }, {
    heading: '6. Cambios en esta Política',
    text: 'Nos reservamos el derecho de actualizar esta política de privacidad en cualquier momento. Te notificaremos sobre cambios significativos publicando la nueva política en nuestro sitio web con la fecha de la última actualización.'
  }]
};
const termsContent = {
  title: 'Términos y Condiciones',
  sections: [{
    heading: '1. Aceptación de los Términos',
    text: 'Al acceder y utilizar este sitio web y adquirir nuestros productos digitales, aceptas estar sujeto a estos términos y condiciones. Si no estás de acuerdo con alguna parte de estos términos, no debes utilizar nuestro sitio ni adquirir nuestros productos.'
  }, {
    heading: '2. Productos Digitales',
    text: 'El Método Reseteo H2 y todos los bonos incluidos son productos digitales entregados en formato electrónico. Una vez completada la compra, recibirás acceso inmediato al contenido a través del correo electrónico proporcionado. Los productos son para uso personal y no pueden ser redistribuidos, copiados ni compartidos.'
  }, {
    heading: '3. Descargo de Responsabilidad Médica',
    text: 'El contenido proporcionado en el Método Reseteo H2 es solo con fines informativos y educativos. No sustituye el consejo médico profesional, el diagnóstico ni el tratamiento. Siempre consulta a tu médico u otro profesional de la salud calificado antes de comenzar cualquier programa de nutrición o ejercicio. Los resultados pueden variar de persona a persona.'
  }, {
    heading: '4. Política de Reembolso',
    text: 'Ofrecemos una garantía de devolución de dinero de 7 días. Si dentro de los 7 días posteriores a tu compra no estás satisfecha con el producto, puedes solicitar un reembolso completo. Para solicitar un reembolso, simplemente contacta a nuestro equipo de soporte. El reembolso se procesará en un plazo de 5 a 10 días hábiles.'
  }, {
    heading: '5. Propiedad Intelectual',
    text: 'Todo el contenido incluido en el Método Reseteo H2, incluyendo textos, gráficos, imágenes, recetas y metodologías, está protegido por derechos de autor. Queda prohibida la reproducción, distribución o transmisión de cualquier parte del contenido sin autorización previa por escrito.'
  }, {
    heading: '6. Limitación de Responsabilidad',
    text: 'En ningún caso seremos responsables de daños indirectos, incidentales, especiales o consecuentes que resulten del uso o la imposibilidad de uso de nuestros productos. Nuestra responsabilidad total no excederá el monto pagado por el producto.'
  }, {
    heading: '7. Modificaciones',
    text: 'Nos reservamos el derecho de modificar estos términos y condiciones en cualquier momento. Las modificaciones entrarán en vigor inmediatamente después de su publicación en el sitio web. El uso continuado del sitio después de dichas modificaciones constituye tu aceptación de los nuevos términos.'
  }]
};
export function Footer() {
  const [activeModal, setActiveModal] = useState<ModalType>(null);
  const closeModal = useCallback(() => setActiveModal(null), []);
  useEffect(() => {
    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === 'Escape') closeModal();
    };
    if (activeModal) {
      document.addEventListener('keydown', handleEscape);
      document.body.style.overflow = 'hidden';
    }
    return () => {
      document.removeEventListener('keydown', handleEscape);
      document.body.style.overflow = '';
    };
  }, [activeModal, closeModal]);
  const content = activeModal === 'privacy' ? privacyContent : activeModal === 'terms' ? termsContent : null;
  return <>
      <footer className="bg-charcoal text-white/60 py-10 text-center font-sans text-sm" data-id="element-30">
        <div className="max-w-7xl mx-auto px-4" data-id="element-31">
          <p className="text-white/50" data-id="element-32">
            © {new Date().getFullYear()} Reseteo H2. Todos los derechos
            reservados.
          </p>
          <div className="mt-4 flex items-center justify-center gap-3" data-id="element-33">
            <button onClick={() => setActiveModal('terms')} className="hover:text-white transition-colors duration-200 underline underline-offset-2 decoration-white/20 hover:decoration-white/60" data-id="element-34">
              Términos y Condiciones
            </button>
            <span className="text-white/20" data-id="element-35">|</span>
            <button onClick={() => setActiveModal('privacy')} className="hover:text-white transition-colors duration-200 underline underline-offset-2 decoration-white/20 hover:decoration-white/60" data-id="element-36">
              Política de Privacidad
            </button>
          </div>
          <p className="mt-6 text-xs text-white/30 max-w-2xl mx-auto leading-relaxed" data-id="element-37">
            Este producto no sustituye el consejo médico profesional. Los
            resultados pueden variar de persona a persona.
          </p>
        </div>
      </footer>

      {/* Modal */}
      <AnimatePresence data-id="element-38">
        {activeModal && content && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2
      }} className="fixed inset-0 z-[100] flex items-center justify-center p-4 sm:p-6" onClick={closeModal} data-id="element-39">
            {/* Backdrop */}
            <div className="absolute inset-0 bg-charcoal/80 backdrop-blur-sm" data-id="element-40" />

            {/* Modal Content */}
            <motion.div initial={{
          opacity: 0,
          y: 24,
          scale: 0.97
        }} animate={{
          opacity: 1,
          y: 0,
          scale: 1
        }} exit={{
          opacity: 0,
          y: 16,
          scale: 0.97
        }} transition={{
          duration: 0.3,
          ease: [0.22, 1, 0.36, 1]
        }} onClick={e => e.stopPropagation()} className="relative bg-softwhite rounded-2xl shadow-2xl w-full max-w-2xl max-h-[85vh] overflow-hidden z-10" data-id="element-41">
              {/* Header */}
              <div className="sticky top-0 bg-softwhite border-b border-cream px-6 sm:px-8 py-5 flex items-center justify-between z-10" data-id="element-42">
                <h2 className="font-playfair text-2xl font-bold text-charcoal" data-id="element-43">
                  {content.title}
                </h2>
                <button onClick={closeModal} className="w-10 h-10 rounded-full bg-cream hover:bg-sage/20 flex items-center justify-center text-charcoal-light hover:text-charcoal transition-colors" aria-label="Cerrar" data-id="element-44">
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24" data-id="element-45">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" data-id="element-46" />
                  </svg>
                </button>
              </div>

              {/* Body */}
              <div className="px-6 sm:px-8 py-6 overflow-y-auto max-h-[calc(85vh-76px)] space-y-8" data-id="element-47">
                <p className="text-sm text-charcoal-light font-sans" data-id="element-48">
                  Última actualización:{' '}
                  {new Date().toLocaleDateString('es-ES', {
                year: 'numeric',
                month: 'long',
                day: 'numeric'
              })}
                </p>

                {content.sections.map((section, index) => <div key={index} data-id="element-49">
                    <h3 className="font-playfair font-bold text-lg text-charcoal mb-3" data-id="element-50">
                      {section.heading}
                    </h3>
                    <p className="text-charcoal-light font-sans leading-relaxed text-[15px]" data-id="element-51">
                      {section.text}
                    </p>
                  </div>)}
              </div>
            </motion.div>
          </motion.div>}
      </AnimatePresence>
    </>;
}